import { FC } from "react";
import PageTemplate from "../PageTemplate";
import NotificationsPage from "./NotificationsPage";

const Notifications: FC = () => {
    return <PageTemplate Page={NotificationsPage} />;
};

export default Notifications;
